import {createContext} from 'react';

const ReportContext = createContext(null);

export default ReportContext;
